import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CardTick from "../assets/images/card-tick.png";
import ColorFilter from "../assets/images/colorfilter.png";
import DeviceMessage from "../assets/images/device-message.png";
import StatusUp from "../assets/images/status-up.png";
import { UserContext } from '../components/context/UserContext';
import axios from "axios";

export default function UpgradePlanU() {
  const [plans, setPlans] = useState([]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/plans`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPlans(res.data?.data || []);
      } catch (err) {
        console.error("Errore nel recupero dei piani:", err);
      }
    };

    fetchPlans();
  }, []);

  const handleStartNow = (planId) => {
    const subscription = Array.isArray(user?.subscriptions) && user.subscriptions.length > 0
      ? user.subscriptions[0]
      : null;

    if (subscription) {
      navigate(`/payment?sub_id=${subscription.id}`);
    } else {
      navigate(`/payment?plan_id=${planId}`);
    }
  };

  return (
    <div className="bg-[#191919] m-5 p-5 rounded-2xl flex flex-col gap-10 items-center text-center">
      <div className="flex flex-col max-w-[50%] gap-5">
        <h1 className="text-5xl m-0">Unlock the Power of Advanced Features</h1>
        <div className="flex flex-col">
          <h2 className="text-xl font-semibold mb-2">
            Ready to take your AI platform to the next level?
          </h2>
          <p>
            Upgrade to the Advanced Plan and experience how effortless building your own AI-as-a-service platform can be: with powerful tools, seamless workflows, and exclusive access to a curated selection of startups, matched and evaluated to fit your search.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-5">
        {[{
          icon: DeviceMessage, title: "AI-Powered Startup Discovery", desc: "Automatically identify the most relevant startups based on your goals and preferences.",
        }, {
          icon: ColorFilter, title: "Decision Intelligence Matrix", desc: "A structured evaluation framework to compare and rank startups effectively.",
        }, {
          icon: CardTick, title: "Strategic Recommendations", desc: "Actionable insights to help you make confident, high-impact decisions.",
        }, {
          icon: StatusUp, title: "Result Analysis & Custom Reports", desc: "Generate clear, data-driven reports to support internal discussions",
        }].map(({ icon, title, desc }) => (
          <div key={title} className="flex flex-col rounded-2xl border border-[#656565] p-5 bg-[#272727]">
            <img src={icon} alt={title} className="w-12 h-12 mb-4 mx-auto" />
            <h2 className="text-2xl font-semibold">{title}</h2>
            <p className="text-base">{desc}</p>
          </div>
        ))}
      </div>

      <div className="flex flex-col max-w-[50%] gap-5 mt-10">
        <h1 className="text-5xl m-0">Choose the Plan for You</h1>
      </div>

      <div className={`grid gap-10 w-full max-w-4xl ${plans.length === 1 ? "grid-cols-1 place-items-center" : "grid-cols-1 md:grid-cols-2"}`}>
        {plans.map(plan => {
          const subscription = Array.isArray(user?.subscriptions) && user.subscriptions.length > 0
            ? user.subscriptions[0]
            : null;
                
          const hasSubscription = !!subscription;
          const isCurrentPlan = hasSubscription && subscription.plan_id === parseInt(plan.id);
          const isUpgrade = hasSubscription && !isCurrentPlan;
                
          const handleClick = () => {
            if (!hasSubscription) {
              navigate(`/payment?plan_id=${plan.id}`);
            } else if (isCurrentPlan) {
              navigate(`/payment?sub_id=${subscription.id}`); // rinnovo
            } else {
              navigate(`/payment?plan_id=${plan.id}`); // upgrade
            }
          };
        
          const buttonLabel = !hasSubscription
            ? 'Start Now'
            : isCurrentPlan
            ? 'Renew'
            : 'Upgrade';
        
          return (
            <div key={plan.id} className="bg-[#272727] border border-[#656565] rounded-2xl p-6 flex flex-col gap-4">
              <div className="bg-[#C5FF55] rounded-full py-1 px-4 w-fit mx-auto text-sm text-black font-semibold">
                {plan.name.toUpperCase()} PLAN
              </div>
              <p className="text-[#fff] m-0">
                {plan.name === "Basic"
                  ? "A streamlined experience with all the essential features to get started:"
                  : "Everything in the Basic Plan, plus powerful tools to take your scouting to the next level:"}
              </p>
              <ul className="text-left flex flex-col gap-2 m-0">
                {plan.name === "Basic" ? (
                  <>
                    <li>✔ Startup repository</li>
                    <li>✔ Smart filtering system</li>
                    <li>✔ AI Navigator</li>
                    <li>✔ Direct chat with startups</li>
                  </>
                ) : (
                  <>
                    <li>✔ Advanced evaluation tools</li>
                    <li>✔ AI-powered startup recommendations</li>
                    <li>✔ Side-by-side startup comparisons</li>
                    <li>✔ Customizable reports</li>
                  </>
                )}
              </ul>
              
              <button
                onClick={handleClick}
                className="mt-auto bg-[#C5FF55] hover:bg-[#d6ff70] text-black rounded-full px-6 py-2 font-semibold"
              >
                {buttonLabel}
              </button>
            </div>
          );
        })}

      </div>
    </div>
  );
}
